"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[2781],{

/***/ 18946:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": () => (/* binding */ LINDA_MAMA_ID),
/* harmony export */   "A": () => (/* binding */ NATIONAL_ID_NUMBER),
/* harmony export */   "Ec": () => (/* binding */ TOTAL),
/* harmony export */   "LT": () => (/* binding */ BALANCE),
/* harmony export */   "TF": () => (/* binding */ INSURER_DETAILS),
/* harmony export */   "ev": () => (/* binding */ NHIF),
/* harmony export */   "fh": () => (/* binding */ INSURER_TYPE),
/* harmony export */   "gh": () => (/* binding */ INSURER_NAME),
/* harmony export */   "hN": () => (/* binding */ PRIVATE_INSURANCE),
/* harmony export */   "iE": () => (/* binding */ INSURER_DETAILS_NAME),
/* harmony export */   "lj": () => (/* binding */ INSURER),
/* harmony export */   "nu": () => (/* binding */ MEMBERSHIP_NUMBER),
/* harmony export */   "o3": () => (/* binding */ DEPENDENT),
/* harmony export */   "rL": () => (/* binding */ PATIENT),
/* harmony export */   "rl": () => (/* binding */ PROPERTIES),
/* harmony export */   "tT": () => (/* binding */ INSURERS)
/* harmony export */ });
/* unused harmony exports MEMBER, SPOUSE, CHILD, DEPENDENTSPOUSE, DEPENDENTCHILD */
const INSURERS = "payers";
const INSURER_NAME = "name";
const INSURER_DETAILS = "insuranceDetails";
const INSURER_DETAILS_NAME = "name";
const MEMBERSHIP_NUMBER = "insuranceNumber";
const NATIONAL_ID_NUMBER = "nationalIdNumber";
const DEPENDENT = "dependent";
const MEMBER = "MEMBER";
const SPOUSE = "SPOUSE";
const CHILD = "CHILD";
const DEPENDENTSPOUSE = "DEPENDENTSPOUSE";
const DEPENDENTCHILD = "DEPENDENTCHILD";
const PATIENT = "PATIENT";
const INSURER = "INSURER";
const INSURER_TYPE = "type";
const BALANCE = "balance";
const TOTAL = "total";
const NHIF = "NHIF";
const PRIVATE_INSURANCE = "Private";
const PROPERTIES = "properties";
const LINDA_MAMA_ID = "LM";


/***/ }),

/***/ 55535:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ useValidationSchema)
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85961);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52018);
/* harmony import */ var elephant_web_client_utils_useTerritory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29346);
/* harmony import */ var elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20589);
/* harmony import */ var _formConstants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18946);
/* harmony import */ var elephant_web_gql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3047);






const useValidationSchema = (totalAmount) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const territory = (0,elephant_web_client_utils_useTerritory__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  return (0,yup__WEBPACK_IMPORTED_MODULE_0__.object)({
    [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .INSURERS */ .tT]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.array)().of(
      (0,yup__WEBPACK_IMPORTED_MODULE_0__.object)({
        [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .INSURER_TYPE */ .fh]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)().required(),
        [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .INSURER_NAME */ .gh]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)().required(),
        [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .PROPERTIES */ .rl]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.array)().of((0,yup__WEBPACK_IMPORTED_MODULE_0__.object)({})),
        [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .BALANCE */ .LT]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.object)({
          [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .TOTAL */ .Ec]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.number)().required(
            formatMessage({
              id: "invoice.insurer.balance.required",
              defaultMessage: "Please enter an amount"
            })
          ).integer().positive(
            formatMessage({
              id: "invoicing.insurers.balance.error",
              defaultMessage: "Must be greater than 0"
            })
          ).test({
            name: "maxTotal",
            exclusive: false,
            params: { totalAmount },
            message: formatMessage({
              id: "invoice.insurer.balance.max",
              defaultMessage: "Insurance cannot exceed total"
            }),
            test: (_, context) => {
              var _a, _b;
              const currentInsurers = (_b = (_a = context == null ? void 0 : context.options) == null ? void 0 : _a.from[2]) == null ? void 0 : _b.value[_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .INSURERS */ .tT];
              const currentPaidTotal = currentInsurers == null ? void 0 : currentInsurers.reduce(
                (a, b) => a + b.balance.total,
                0
              );
              return currentPaidTotal <= totalAmount;
            }
          })
        }),
        [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .INSURER_DETAILS */ .TF]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.object)({
          [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .INSURER_DETAILS_NAME */ .iE]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)(),
          [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .MEMBERSHIP_NUMBER */ .nu]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => {
            switch (territory) {
              case elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .TERRITORY.KENYA */ .jQ.KENYA:
                return (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)().matches(
                  /^[a-zA-Z0-9]{7,8}$/,
                  formatMessage({
                    id: "invoicing.insurers.insuranceNumber.kenya.error",
                    defaultMessage: "Please enter 7 or 8 alphanumeric characters"
                  })
                ).required();
              case elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .TERRITORY.LEBANON */ .jQ.LEBANON:
                return (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)().matches(
                  /^[0-9]{8}$/,
                  formatMessage({
                    id: "invoicing.insurers.insuranceNumber.error",
                    defaultMessage: "Please enter 8 digits"
                  })
                ).required();
              default:
                return (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)().required();
            }
          }),
          [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .DEPENDENT */ .o3]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)().when(_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .INSURER_NAME */ .gh, {
            is: (name) => name === _formConstants__WEBPACK_IMPORTED_MODULE_5__/* .NHIF */ .ev,
            then: (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)().oneOf(
              [
                elephant_web_gql__WEBPACK_IMPORTED_MODULE_3__/* .Dependent.Member */ .eC.Member,
                elephant_web_gql__WEBPACK_IMPORTED_MODULE_3__/* .Dependent.Dependentchild */ .eC.Dependentchild,
                elephant_web_gql__WEBPACK_IMPORTED_MODULE_3__/* .Dependent.Dependentspouse */ .eC.Dependentspouse,
                elephant_web_gql__WEBPACK_IMPORTED_MODULE_3__/* .Dependent.Spouse */ .eC.Spouse,
                elephant_web_gql__WEBPACK_IMPORTED_MODULE_3__/* .Dependent.Child */ .eC.Child
              ],
              formatMessage({
                id: "invoicing.insurers.dependent.error",
                defaultMessage: "You must select one of the values from the Dependents dropdown menu"
              })
            ).required(
              formatMessage({
                id: "invoicing.insurers.dependent.required.error",
                defaultMessage: "You must select one of the values from the Dependents dropdown menu"
              })
            ),
            otherwise: (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)().nullable()
          }),
          [_formConstants__WEBPACK_IMPORTED_MODULE_5__/* .NATIONAL_ID_NUMBER */ .A]: (0,yup__WEBPACK_IMPORTED_MODULE_0__.string)().nullable()
        })
      })
    ).nullable()
  });
};


/***/ }),

/***/ 59300:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* reexport */ InsurerAccordion)
});

// UNUSED EXPORTS: FormattedDependentInEnglish, InsurerPropType

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Accordion/Accordion.js
var Accordion = __webpack_require__(74150);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(92473);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(41706);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/formConstants.ts
var formConstants = __webpack_require__(18946);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./src/client/forms/inputs/TextField.tsx
var TextField = __webpack_require__(78802);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.8.36/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(4548);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./src/client/billing/BillingProvider.tsx + 1 modules
var BillingProvider = __webpack_require__(78768);
// EXTERNAL MODULE: ./src/client/utils/useCurrencyFormat.ts
var useCurrencyFormat = __webpack_require__(13856);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useFetchPatientDetails.tsx + 1 modules
var useFetchPatientDetails = __webpack_require__(18921);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/RebateNHIF.tsx










const useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  rebateField: {
    width: "33%",
    "& .MuiFormLabel-root.Mui-disabled": {
      color: theme.palette.common.black,
      margin: 0
    },
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.common.white,
      fontWeight: "bold"
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: theme.palette.common.black,
      padding: "8px 0"
    }
  }
}));
const CLINIC_INSURANCE_QUERY = lib/* gql */.Ps`
  query clinicInsurance {
    clinicInsurance {
      id
      dailyRebateAmount
    }
  }
`;
const RebateNHIF = ({ invoiceId }) => {
  var _a, _b, _c, _d, _e;
  const classes = useStyles();
  const currencyDetails = (0,BillingProvider/* useBillingCurrency */.eZ)();
  const currencyFormatter = (0,useCurrencyFormat/* default */.Z)(currencyDetails);
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { inpatientDetails } = (0,useFetchPatientDetails/* default */.Z)(invoiceId);
  const { data: insuranceData } = (0,useQuery/* useQuery */.a)(CLINIC_INSURANCE_QUERY);
  if (inpatientDetails && ((_a = insuranceData == null ? void 0 : insuranceData.clinicInsurance) == null ? void 0 : _a.dailyRebateAmount)) {
    const admission = dayjs_min_default()(inpatientDetails.admission);
    const discharge = dayjs_min_default()(inpatientDetails.discharge);
    const datesAreValid = admission.isValid() && discharge.isValid();
    const numberOfDays = datesAreValid ? discharge.diff(admission, "day", true) : 0;
    const rebateAmount = (_c = (_b = insuranceData == null ? void 0 : insuranceData.clinicInsurance) == null ? void 0 : _b.dailyRebateAmount) != null ? _c : 0;
    const rebateTotal = rebateAmount * numberOfDays;
    return /* @__PURE__ */ react.createElement("div", {
      style: { marginTop: "48px" }
    }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, null, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "invoice.payers.nhif.rebateDetails.heading",
      defaultMessage: "Rebate"
    }))), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
      variant: "body2"
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "invoice.payers.nhif.rebateDetails.info",
      defaultMessage: "The full rebate amount is calculated by multiplying the daily rebate fee with the number of admitted nights."
    })), /* @__PURE__ */ react.createElement("div", {
      style: { marginTop: "18px" }
    }, /* @__PURE__ */ react.createElement(TextField/* default */.Z, {
      disabled: true,
      value: (_d = currencyFormatter == null ? void 0 : currencyFormatter.format(rebateAmount)) != null ? _d : rebateAmount,
      label: formatMessage({
        id: "invoice.payers.nhif.rebateDetails.dailyAmount",
        defaultMessage: "Daily rebate fee"
      }),
      className: classes.rebateField,
      "data-testid": "invoice.payers.nhif.rebate.dailyAmount"
    }), /* @__PURE__ */ react.createElement(TextField/* default */.Z, {
      disabled: true,
      value: numberOfDays,
      label: formatMessage({
        id: "invoice.payers.nhif.rebateDetails.numberOfDays",
        defaultMessage: "Days as an inpatient"
      }),
      className: classes.rebateField,
      "data-testid": "invoice.payers.nhif.rebate.numberOfDays"
    }), /* @__PURE__ */ react.createElement(TextField/* default */.Z, {
      disabled: true,
      value: (_e = currencyFormatter == null ? void 0 : currencyFormatter.format(rebateTotal)) != null ? _e : rebateTotal,
      label: formatMessage({
        id: "invoice.payers.nhif.rebateDetails.total",
        defaultMessage: "Rebate amount"
      }),
      className: classes.rebateField,
      "data-testid": "invoice.payers.nhif.rebate.totalAmount"
    })));
  }
  return null;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.27.0/node_modules/ramda/es/path.js + 2 modules
var path = __webpack_require__(98806);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(66264);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(90898);
// EXTERNAL MODULE: ./src/client/utils/useConvertCurrency.js
var useConvertCurrency = __webpack_require__(59807);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/InsurerSummary.tsx












const InsurerSummary_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  expandIcon: {
    transform: ({ expanded }) => expanded ? "rotate(0deg)" : "rotate(180deg)",
    transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
  },
  cost: {
    height: "60px"
  },
  currency: {
    marginTop: theme.spacing(3)
  },
  label: {
    color: theme.palette.grey.dark,
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px"
    }
  },
  disabled: {
    color: theme.palette.text.primary
  }
}));
const InsurerSummary = ({
  index,
  expanded,
  setExpanded,
  insuranceName
}) => {
  var _a;
  const classes = InsurerSummary_useStyles({ expanded });
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const currency = (0,useCurrencyFormat/* default */.Z)();
  const penceToPounds = (0,useConvertCurrency/* useConvertFromPenceFactory */.YQ)();
  const poundsToPence = (0,useConvertCurrency/* useConvertFromPoundsFactory */.Pt)();
  const { setValue, register, formState } = (0,index_esm/* useFormContext */.Gc)();
  const costFormFieldPath = `${formConstants/* INSURERS */.tT}.${index}.${formConstants/* BALANCE */.LT}.${formConstants/* TOTAL */.Ec}`;
  (0,react.useEffect)(() => {
    register(costFormFieldPath);
  }, [register, costFormFieldPath]);
  const expandButtonLabel = expanded ? formatMessage({
    id: "insuranceAccordion.hide-insurance-details",
    defaultMessage: "Hide Insurance Details"
  }) : formatMessage({
    id: "insuranceAccordion.show-insurance-details",
    defaultMessage: "Show Insurance Details"
  });
  const costLabel = formatMessage({
    id: "insuranceAccordion.summary.amount",
    defaultMessage: "Price"
  });
  const watchedCost = (0,index_esm/* useWatch */.qo)({ name: costFormFieldPath });
  const formattedCurrency = currency == null ? void 0 : currency.formatToParts(Number(currency))[0].value;
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 8
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h6"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "insuranceAccordion.summary.insuranceName",
    defaultMessage: "{insuranceName}",
    values: { insuranceName }
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: true,
    className: classes.cost
  }, /* @__PURE__ */ react.createElement(TextField/* default */.Z, {
    name: costFormFieldPath,
    label: costLabel,
    type: "number",
    InputLabelProps: { classes: { root: classes.label } },
    error: (_a = (0,path/* default */.Z)(costFormFieldPath.split("."), formState.errors)) == null ? void 0 : _a.message,
    InputProps: {
      value: penceToPounds(watchedCost),
      inputProps: { min: "0.00", step: "0.01" },
      onChange: (e) => {
        setValue(costFormFieldPath, poundsToPence(e.target.value), {
          shouldDirty: true,
          shouldValidate: true,
          shouldTouch: true
        });
      },
      classes: { disabled: classes.disabled },
      startAdornment: formattedCurrency && /* @__PURE__ */ react.createElement(InputAdornment/* default */.Z, {
        position: "start"
      }, /* @__PURE__ */ react.createElement("p", {
        className: classes.currency
      }, formattedCurrency || ""))
    }
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
    onClick: () => setExpanded(!expanded),
    "aria-label": expandButtonLabel
  }, /* @__PURE__ */ react.createElement(ExpandMore/* default */.Z, {
    className: classes.expandIcon
  }))));
};
/* harmony default export */ const InsurerAccordion_InsurerSummary = ((/* unused pure expression or super */ null && (InsurerSummary)));

// EXTERNAL MODULE: ./src/client/forms/hookForm/index.ts
var hookForm = __webpack_require__(86347);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/ConditionalDisplay/index.ts + 1 modules
var ConditionalDisplay = __webpack_require__(7195);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/InsurerDetails.tsx








const InsurerDetails = ({
  index,
  insurerType,
  insurerProperties
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { formState } = (0,index_esm/* useFormContext */.Gc)();
  const { errors } = formState;
  const membershipNumberField = `${formConstants/* INSURERS */.tT}.${index}.${formConstants/* INSURER_DETAILS */.TF}.${formConstants/* MEMBERSHIP_NUMBER */.nu}`;
  const nationalIdNumberField = `${formConstants/* INSURERS */.tT}.${index}.${formConstants/* INSURER_DETAILS */.TF}.${formConstants/* NATIONAL_ID_NUMBER */.A}`;
  const dependentField = `${formConstants/* INSURERS */.tT}.${index}.${formConstants/* INSURER_DETAILS */.TF}.${formConstants/* DEPENDENT */.o3}`;
  const privateInsuranceLabel = formatMessage({
    id: "insurerAccordion.details.privateInsuranceLabel",
    defaultMessage: "Insurance Name"
  });
  const insuranceNumberLabel = formatMessage({
    id: "insurerAccordion.details.insuranceNumberLabel",
    defaultMessage: "Membership Number"
  });
  const nationalIdNumberLabel = formatMessage({
    id: "insurerAccordion.details.nationalIdNumberLabel",
    defaultMessage: "National ID"
  });
  const dependantsLabel = formatMessage({
    id: "insurerAccordion.details.dependantsLabel",
    defaultMessage: "Dependants"
  });
  const renderOptions = (prop) => {
    var _a;
    return (_a = prop == null ? void 0 : prop.enumTitles) == null ? void 0 : _a.map((enumTitle, idx) => ({
      value: prop == null ? void 0 : prop.enum[idx],
      label: enumTitle
    }));
  };
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: insurerType === formConstants/* PRIVATE_INSURANCE */.hN
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: true
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    name: `${formConstants/* INSURERS */.tT}.${index}.${formConstants/* INSURER_DETAILS */.TF}.${formConstants/* INSURER_DETAILS_NAME */.iE}`,
    label: privateInsuranceLabel,
    fullWidth: true
  }))), insurerProperties == null ? void 0 : insurerProperties.map((prop) => {
    var _a;
    return /* @__PURE__ */ react.createElement(react.Fragment, {
      key: prop.name
    }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
      condition: prop.name === formConstants/* MEMBERSHIP_NUMBER */.nu
    }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
      item: true,
      xs: true
    }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
      name: membershipNumberField,
      label: insuranceNumberLabel,
      fullWidth: true
    }))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
      condition: prop.name === formConstants/* NATIONAL_ID_NUMBER */.A
    }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
      item: true,
      xs: true
    }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
      name: nationalIdNumberField,
      label: nationalIdNumberLabel,
      fullWidth: true
    }))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
      condition: prop.name === formConstants/* DEPENDENT */.o3
    }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
      item: true,
      xs: true
    }, /* @__PURE__ */ react.createElement(hookForm/* RHFSelectField */.DM, {
      name: dependentField,
      label: dependantsLabel,
      options: renderOptions(prop),
      error: (_a = (0,path/* default */.Z)(dependentField.split("."), errors)) == null ? void 0 : _a.message,
      fullWidth: true
    }))));
  }));
};
/* harmony default export */ const InsurerAccordion_InsurerDetails = ((/* unused pure expression or super */ null && (InsurerDetails)));

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Delete.js
var Delete = __webpack_require__(7056);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/InsurerDetailsActions.tsx





const InsurerDetailsActions = ({
  deleteInsurer
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    justifyContent: "flex-end",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    textAlign: "right",
    pb: 2
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
    onClick: deleteInsurer,
    color: "alert",
    "aria-label": formatMessage({
      id: "insurerDetails.actions.delete",
      defaultMessage: "Delete Insurer"
    })
  }, /* @__PURE__ */ react.createElement(Delete/* default */.Z, null)))));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/InsurerAccordion.tsx









const InsurerAccordion_useStyles = (0,dist_module/* makeStyles */.Z)({
  root: {
    "&.Mui-focused": {
      backgroundColor: "inherit"
    }
  }
});
const findAddedInsurer = (insurers, name) => {
  return insurers.find((i) => i.name === name);
};
const InsurerAccordion = ({
  insurer,
  index,
  handleRemoveInsurer,
  insurers,
  invoiceId
}) => {
  var _a, _b;
  const classes = InsurerAccordion_useStyles();
  const [expanded, setExpanded] = react.useState(true);
  const insurerName = insurer.type !== formConstants/* PRIVATE_INSURANCE */.hN ? (_a = insurer.insuranceDetails) == null ? void 0 : _a.name : insurer == null ? void 0 : insurer.name;
  const invoiceSummaryProps = {
    index,
    expanded,
    setExpanded,
    insuranceName: insurerName
  };
  const addedInsurerProperties = (_b = findAddedInsurer(
    insurers,
    insurer == null ? void 0 : insurer.name
  )) == null ? void 0 : _b.properties;
  const deleteInsurer = () => {
    handleRemoveInsurer(index);
  };
  return /* @__PURE__ */ react.createElement(Accordion/* default */.Z, {
    expanded,
    elevation: 0
  }, /* @__PURE__ */ react.createElement(AccordionSummary/* default */.Z, {
    classes: { root: classes.root }
  }, /* @__PURE__ */ react.createElement(InsurerSummary, {
    ...invoiceSummaryProps
  })), /* @__PURE__ */ react.createElement(AccordionDetails/* default */.Z, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(InsurerDetails, {
    index,
    insurerType: insurer == null ? void 0 : insurer.type,
    insurerProperties: (insurer == null ? void 0 : insurer.properties) || addedInsurerProperties
  }), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: insurerName === formConstants/* NHIF */.ev
  }, /* @__PURE__ */ react.createElement(RebateNHIF, {
    invoiceId
  })), /* @__PURE__ */ react.createElement(InsurerDetailsActions, {
    deleteInsurer
  })))));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/types.ts
var FormattedDependentInEnglish = /* @__PURE__ */ ((FormattedDependentInEnglish2) => {
  FormattedDependentInEnglish2["MEMBER"] = "Member";
  FormattedDependentInEnglish2["DEPENDENT_SPOUSE"] = "Dependant (Spouse)";
  FormattedDependentInEnglish2["DEPENDENT_CHILD"] = "Dependant (Child)";
  return FormattedDependentInEnglish2;
})(FormattedDependentInEnglish || {});
var GhaneanFormattedDependentInEnglish = /* @__PURE__ */ ((GhaneanFormattedDependentInEnglish2) => {
  GhaneanFormattedDependentInEnglish2["MEMBER"] = "Member";
  GhaneanFormattedDependentInEnglish2["DEPENDENT_CHILD"] = "Dependant (< 3 months old)";
  return GhaneanFormattedDependentInEnglish2;
})(GhaneanFormattedDependentInEnglish || {});
var FormattedDependentInFrench = /* @__PURE__ */ ((FormattedDependentInFrench2) => {
  FormattedDependentInFrench2["MEMBER"] = "Membre";
  FormattedDependentInFrench2["DEPENDENT_SPOUSE"] = "D\xE9pendant (spouce)";
  FormattedDependentInFrench2["DEPENDENT_CHILD"] = "D\xE9pendant (enfant)";
  return FormattedDependentInFrench2;
})(FormattedDependentInFrench || {});
var GhaneanFormattedDependentInFrench = /* @__PURE__ */ ((GhaneanFormattedDependentInFrench2) => {
  GhaneanFormattedDependentInFrench2["MEMBER"] = "Membre";
  GhaneanFormattedDependentInFrench2["DEPENDENT_CHILD"] = "D\xE9pendant (< 3 mois)";
  return GhaneanFormattedDependentInFrench2;
})(GhaneanFormattedDependentInFrench || {});
var InsurerPropType = /* @__PURE__ */ ((InsurerPropType2) => {
  InsurerPropType2["INSURANCE_NUMBER"] = "insuranceNumber";
  InsurerPropType2["NATIONAL_ID_NUMBER"] = "nationalIdNumber";
  InsurerPropType2["DEPENDENT"] = "dependent";
  return InsurerPropType2;
})(InsurerPropType || {});

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/index.ts




/***/ })

}]);